import "./ProxyModal.scss"

import { TabBar } from "@skylead/component-library"
import React, { useState } from "react"

import { store } from "../../../redux/store"
import { useGlobalTranslation } from "../../../utils/hook"
import InputGroup from "../../organisms/InputGroup"
import LangText from "../LangText"

const ProxyModal = () => {
  const { tt } = useGlobalTranslation()
  const { showDefaultProxies } = store.getState().forms.formData

  const [selectedTab, setSelectedTab] = useState(showDefaultProxies || false)

  const proxiesTabBarItems = [
    {
      canView: true,
      label: tt("available-proxies"),
      isActive: selectedTab,
      onClick: () => {
        setSelectedTab(true)
      },
    },
    {
      canView: true,
      label: tt("custom-proxy"),
      isActive: !selectedTab,
      onClick: () => {
        setSelectedTab(false)
      },
    },
  ]
  return (
    <div className="proxy-modal-wrapper">
      <div className="new-tabs-design">
        <div className="tabs-wrapepr">
          <TabBar items={proxiesTabBarItems} />
        </div>
        {selectedTab ? (
          <div>
            <InputGroup
              field="selectedProxy"
              type="select"
              inputGroupClassName="input-on-surface"
              label={tt("proxy.modal.input.label")}
            >
              {store.getState().app.proxyCountries.map(option => (
                <option key={option.countryCode} value={option.countryCode}>
                  {option.countryName}
                </option>
              ))}
            </InputGroup>
            <span>
              <LangText langKey="proxy.modal.input.msg" />
            </span>
          </div>
        ) : (
          <>
            <InputGroup
              field="proxyHostWithPort"
              inputGroupClassName="input-on-surface"
              label={tt("proxy.modal.proxy-host.input.label")}
              placeholder={tt("proxy.modal.proxy-host.input.placeholder")}
            />
            <InputGroup
              field="proxyUsername"
              inputGroupClassName="input-on-surface"
              label={tt("proxy.modal.proxy-username.input.label")}
              placeholder={tt("proxy.modal.proxy-username.input.placeholder")}
            />
            <InputGroup
              field="proxyPassword"
              inputGroupClassName="input-on-surface"
              label={tt("proxy.modal.proxy-password.input.label")}
              placeholder={tt("proxy.modal.proxy-password.input.placeholder")}
              type="password"
              passwordType="password"
            />
          </>
        )}
      </div>
    </div>
  )
}

export default ProxyModal
